import { lazy } from "react";

export const ContractPage = lazy(() =>
  import("./ContractPage.jsx").then((module) => ({
    default: module.default,
  }))
);
